const Separator = '/';

//Page name only
export const Page = {
  // Authorization
  Login: 'admin',
  Register: 'register',
  Awsauth: 'Awsauth',
  AccountCreated: 'AccountCreated',
  Forget: 'forget',
  ResetPassword: 'reset-password',
  UpdatePhone: 'update-phone',
  MFACode: 'mfa-code',
  MFAMethod: 'mfa-method',

  // Dashboard
  Dashboard: 'dashboard',
  Test: 'test',
  VotersFuzzySearch: 'voters-fuzzy-search',

  // Pages
  Analytics: 'analytics',
  GeneralElections2024: '2024-general-elections',
  PrimaryElections2025: '2025-primary-elections',
  PrimaryElectionsNov2025: 'nov-2025-primary-elections',
  Voters: 'search-voters-postgres',
  SearchUserClickHouse: 'search-voters-clickhouse',
  UsersManagement: 'users-management',
  VotersListing: 'voters-listing',
  LoginLogs: 'voters-listing-logs',
  VotersListingLogs: 'voters-listing-logs-old',
  AddOwnership: 'add-captain',
  CustomVotersListing: 'custom-voters-listing',
  Statistics: 'home',
  Stats: 'home/analytics',
  Main: '',
  Reasons: 'ballot-reasons',
  ChorplethMap: 'chorpleth-map',
  VoterPopulation: 'voter-population',
  VoterTurnout: 'voter-turnout',
  CommunityDemographics: 'community-demographics',
  CommunityDemographicsHome: 'community-demographics-home',
  CSVUpload: 'voters-data-upload',
  Candidates: 'candidates',
  PrimaryElection2025Home: 'wa/2025-primary',
  VotersGuide: 'voters-guide',
  UploadLogin: 'upload-login',
  CSVBucketUpload: 'csv-bucket-upload',
  S3CSVBucketUpload: 's3-csv-bucket-upload',
  ElectionNov2025Home: 'wa/elections-nov-2025',
  SamplePage: 'sample-page',
  CandidatesLogs: 'candidates-logs',
  Contacts: 'contacts',
  CaptainsRelations: 'captains-relations',
};

//Full url of each Page
export const AmacUrl = {
  // Authorization
  Login: Separator + Page.Login,
  Register: Separator + Page.Register,
  ResetPassword: Separator + Page.ResetPassword,
  UpdatePhone: Separator + Page.UpdatePhone,
  MFAMethod: Separator + Page.MFAMethod,
  MFACode: Separator + Page.MFACode,
  Statistics: Separator + Page.Statistics,
  Stats: Separator + Page.Stats,
  // Dashboard
  Dashboard: Separator + Page.Dashboard,
  Test: Separator + Page.Test,


  //Pages
  Analytics: Separator + Page.Analytics,
  GeneralElections2024: Separator + Page.GeneralElections2024,
  PrimaryElections2025: Separator + Page.PrimaryElections2025,
  UsersManagement: Separator + Page.UsersManagement,
  VotersListing: Separator + Page.VotersListing,
  Voters: Separator + Page.Voters,
  SearchUserClickHouse: Separator + Page.SearchUserClickHouse,
  LoginLogs: Separator + Page.LoginLogs,
  VotersListingLogs: Separator + Page.VotersListingLogs,
  // MyCases: Separator + [Page.Dashboard, Page.MyCases].join(Separator),
  AddOwnership: Separator + Page.AddOwnership,
  CustomVotersListing: Separator + Page.CustomVotersListing,
  Reasons: Separator + Page.Reasons,
  ChorplethMap: Separator + Page.ChorplethMap,
  VoterPopulation: Separator + Page.VoterPopulation,
  VoterTurnout: Separator + Page.VoterTurnout,
  CommunityDemographics: Separator + Page.CommunityDemographics,
  CommunityDemographicsHome: Separator + Page.CommunityDemographicsHome,
  CSVUpload: Separator + Page.CSVUpload,
  Candidates: Separator + Page.Candidates,
  PrimaryElection2025Home: Separator + Page.PrimaryElection2025Home,
  VotersGuide: Separator + Page.VotersGuide,
  UploadLogin: Separator + Page.UploadLogin,
  CSVBucketUpload: Separator + Page.CSVBucketUpload,
  S3CSVBucketUpload: Separator + Page.S3CSVBucketUpload,
  PrimaryElectionsNov2025:  Separator + Page.PrimaryElectionsNov2025,
  ElectionNov2025Home: Separator + Page.ElectionNov2025Home,
  SamplePage:  Separator + Page.SamplePage,
  CandidatesLogs: Separator + Page.CandidatesLogs,
  Contacts: Separator + Page.Contacts,
  CaptainsRelations: Separator + Page.CaptainsRelations,
};
